import './OurService.css'

import Offeringsra from "../../assets/RA.jpg";
import Offeringssc from "../../assets/SC.jpg";
import Offeringsre from "../../assets/REE.jpg";
import Offeringsocm from "../../assets/OCM.jpg";
import Offeringsis from "../../assets/IM.jpg";
import Offeringpes from "../../assets/PES.jpg";
import BusinessDiag from "../../assets/BD.jpg";
import { useNavigate } from 'react-router-dom';

export default function OurService() {

    const navigate = useNavigate();

    const handleNavigate = (productName) => {
        navigate("/individualPages", { state: { productName } });
    };

    return (
        <section className="portfolio-section py-5 bg-light">
            <div className="container">
                <div className="row justify-content-center text-center">
                    <div className="col-lg-8">
                        {/* <p className="behind-designs mb-3 fw-medium">Behind the Designs</p> */}
                        <h1 className="main-heading mb-4 fw-bold" style={{textAlign:'center'}}>
                            Curious About US
                        </h1>
                        {/* <p className="subtitle mb-4 text-muted">
                            Explore more brand identities, packaging, and digital design work in my extended portfolio.
                        </p>
                        <button className="btn btn-projects rounded-pill px-4 py-2 fw-medium">
                            See more Projects
                            <i className="arrow-icon ms-2">→</i>
                        </button> */}
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="cards-container position-relative d-flex justify-content-center align-items-center">
                            <div className="card-3d card-1 position-absolute" onClick={() => handleNavigate("Readiness Assessment")}>
                                <div className="card-inner bg-white rounded-4 shadow-lg overflow-hidden">
                                    <img
                                        src={Offeringsra}
                                        alt="Strategy & Planning"
                                        className="card-image w-100 h-100"
                                    />
                                </div>
                            </div>

                            <div className="card-3d card-2 position-absolute" onClick={() => handleNavigate("Strategic Consulting")}>
                                <div className="card-inner bg-white rounded-4 shadow-lg overflow-hidden">
                                    <img src={Offeringssc} alt="Design work 1" className="grid-image rounded-3" />
                                </div>
                            </div>

                            <div className="card-3d card-3 position-absolute" onClick={() => handleNavigate("Reverse Engineering Engagements")}>
                                <div className="card-inner bg-white rounded-4 shadow-lg overflow-hidden">
                                    <img
                                        src={Offeringsre}
                                        alt="Launch work 1"
                                        className="grid-image rounded-3"
                                    />
                                </div>
                            </div>

                            <div className="card-3d card-4 position-absolute" onClick={() => handleNavigate("Organizational Change Management")}>
                                <div className="card-inner bg-white rounded-4 shadow-lg overflow-hidden">
                                    <img
                                        src={Offeringsocm}
                                        alt="Ongoing Support"
                                        className="card-image w-100 h-100"
                                    />
                                </div>
                            </div>

                            <div className="card-3d card-5 position-absolute" onClick={() => handleNavigate("Implementation Service")}>
                                <div className="card-inner bg-white rounded-4 shadow-lg overflow-hidden">
                                    <img
                                        src={Offeringsis}
                                        alt="Web Development"
                                        className="card-image w-100 h-100"
                                    />
                                </div>
                            </div>

                            <div className="card-3d card-6 position-absolute" onClick={() => handleNavigate("Performance Engineering Services")}>
                                <div className="card-inner bg-white rounded-4 shadow-lg overflow-hidden">
                                    <img src={Offeringpes} alt="Mobile Apps" className="card-image w-100 h-100" />
                                </div>
                            </div>

                            <div className="card-3d card-7 position-absolute" onClick={() => handleNavigate("Business Diagnostics")}>
                                <div className="card-inner bg-white rounded-4 shadow-lg overflow-hidden">
                                    <img
                                        src={BusinessDiag}
                                        alt="Brand Identity"
                                        className="card-image w-100 h-100"
                                    />
                                </div>
                                {/* <div className="card-info text-center mt-3">
                                    <span className="card-number fw-semibold">#07</span>
                                    <h5 className="card-title fw-semibold mt-2 mb-0">Brand Identity</h5>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}